import { Empty } from '@phosphor-icons/react';

export default Empty;